import type { Site } from '../Site';

export const RugbyWorld: Site = {
  id: 'rugbyworld',
  logo: 'rugbyworld.png',
  label: 'Rugby World',
  analyticsName: 'rugbyworld',
  hostname: 'rugbyworld.com',
  platform: 'ti',
  selector: '#content a',
};
